import { Box } from "@mui/material";
import InfoSection from "../../../components/InfoSection";
import InfoGalery from "../../../components/InfoGalery";

const SägenBohren = () => {
  const bullets = [
    "Betonsägen",
    "Zirkelsägen",
    "Betonbohren / Kernbohren",
    "Fugenschneiden",
    "Seilsägen",
  ];
  const pictures = [
    {
      webp: "/media/info/PFLEGER BAUSERVICE INFO-03.webp",
      jpg: "/media/info/PFLEGER BAUSERVICE INFO-03.jpg",
    },
    {
      webp: "/media/info/PFLEGER BAUSERVICE INFO-04.webp",
      jpg: "/media/info/PFLEGER BAUSERVICE INFO-04.jpg",
    },
  ];

  return (
    <Box className="h-full w-full flex flex-col xl:flex-row justify-between items-center p-2 md:p-10 overflow-hidden gap-4">
      <InfoSection
        number={6}
        title="Betonsägen / Kernbohren"
        subTitle="Ihre Garantie für ein solides Bauprojekt."
        bulletArray={bullets}
      />
      <InfoGalery pictures={pictures} />
    </Box>
  );
};

export default SägenBohren;
